module.exports = __webpack_public_path__ + "img/vat.21913d78.svg";